import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const CurtainPants = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.pants.CurtainPants.itemName}
      name={AW23.pants.CurtainPants.itemName}
      price={AW23.pants.CurtainPants.itemPrice}
      fabric={AW23.pants.CurtainPants.itemFabric}
      src={AW23.pants.CurtainPants.sizeChart}
      divId={AW23.pants.CurtainPants.shopifyDivId}
      mainId={AW23.pants.CurtainPants.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.pants.CurtainPants.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.pants.CurtainPants.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default CurtainPants;
